import { render } from "./AdminFaqPage.vue?vue&type=template&id=2910263b"
import script from "./AdminFaqPage.vue?vue&type=script&lang=js"
export * from "./AdminFaqPage.vue?vue&type=script&lang=js"

import "./AdminFaqPage.vue?vue&type=style&index=0&id=2910263b&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__